const commentItems = [
  {
    name: '吃瓜达人小王',
    time: '3小时前',
    content: '51吃瓜最新网址真的太快了！很多爆料我都是在别的地方还没看到，这边就已经更新了。每天的51吃瓜今日黑料视频合集是必看的，吃瓜第一站名不虚传。',
    likes: '2.4k',
  },
  {
    name: '娱乐圈观察员',
    time: '5小时前',
    content: '这个站的信息汇总做得特别好，51吃瓜爆料合集很全面，不像有些网站只有零零散散的几条。每一条51吃瓜黑料都标注了来源，看得出来编辑很用心。',
    likes: '1.8k',
  },
  {
    name: '匿名吃瓜群众',
    time: '8小时前',
    content: '朋友推荐来的，说这里51吃瓜最新爆料更新最快。确实没让我失望，黑料网的内容很丰富，视频也很全。已经加入收藏夹，以后吃瓜就认准这儿了！',
    likes: '1.2k',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[900px] mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          网友热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
          吃瓜群众的真实声音
        </p>
        <div className="flex flex-col gap-4">
          {commentItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 font-heading font-bold text-sm">
                  {item.name.charAt(0)}
                </div>
                <div>
                  <div className="font-heading font-semibold text-sm text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{item.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line text-sm w-4 h-4 flex items-center justify-center"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}